<template>
  <quill-editor
      :content="content"
      :options="{
        modules: {
          toolbar: toolbar,
          keyboard: keyboard
        },
        placeholder: placeholder
      }"
      ref="editor"
      @change="change"
      @blur="blur"
      @focus="focus"
      @ready="ready"
      @click="action"/>
</template>

<script>

import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

let content = { html: '', text: '' };

export default {
  name: 'Editor',
  components: {
    quillEditor
  },
  data () {
    return {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['blockquote', 'link'],
        ['clean']
      ],
      keyboard: {
        bindings: {
          ctrlEnter: {
            key: 13,
            ctrlKey: true,
            handler: () => {
              this.$emit('ctrl-enter', content)
            }
          }
        }
      }
    }
  },
  props: {
    content: {
      type: [String],
      required: false,
      default: ''
    },
    placeholder: {
      type: [String, Number],
      required: false,
      default: ''
    }
  },
  mounted () {
    let editor = this.$refs.editor.quill;
    editor.container.addEventListener('click', () => {
      editor.focus();
    })
  },
  methods: {
    change ($event) {
      content = $event
      this.$emit('change', content)
    },
    blur () {
      this.$emit('blur', content)
    },
    focus () {
      this.$emit('focus', content)
    },
    ready ($event) {
      content.quill = $event;
      content.html = this.content;
      content.text = $event.getText();
      this.$emit('ready', content)
    },
    action () {
      console.log('action');
    }
  }
}

</script>

<style>

.quill-editor {
  margin-bottom: 2em;
  background: #ffffff;
}

.ql-container {
  min-height: 160px;
  font-size: 1em;
}
</style>



// WEBPACK FOOTER //
// Editor.vue?1fd1731c